import * as actions from "./Type";
import Instance from "../util/Instance";
import setToken from "../util/SetToken";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

export const Add_Todo = (bid, data) => {
  return async (dispatch) => {
    if (localStorage.GPC_Agent_token) {
      setToken(localStorage.getItem("GPC_Agent_token"));
    }
    const config = {
      "content-type": "application/json",
    };
    try {
      const res = await Instance.post(
        `/api/v1/newTodo/${bid}`,
        { ...data },
        config
      );
      dispatch(Get_List_Todo());
      dispatch({
        type: actions.ADD_TODO_APP,
        payload: res.data.data,
      });
    } catch (error) {
      toast.error("Todo Created Error");
    }
  };
};

export const Get_List_Todo = () => {
  return async (dispatch) => {
    if (localStorage.GPC_Agent_token) {
      setToken(localStorage.getItem("GPC_Agent_token"));
    }
    const config = {
      "content-type": "application/json",
    };
    try {
      const res = await Instance.get(`/api/v1/getAgentTodos`, config);
      dispatch({
        type: actions.GET_LIST_TODO_APP,
        payload: res.data.data,
      });
    } catch (error) {}
  };
};

export const Update_Checkbox = (id) => {
  return async (dispatch) => {
    if (localStorage.GPC_Agent_token) {
      setToken(localStorage.getItem("GPC_Agent_token"));
    }
    const config = {
      "content-type": "application/json",
    };
    try {
      dispatch({
        type: actions.UPDATEING_TODO_APP_CHECKBOX,
      });
    } catch (error) {}
  };
};

export const Delete_Checkbox = (id) => {
  return async (dispatch) => {
    if (localStorage.GPC_Agent_token) {
      setToken(localStorage.getItem("GPC_Agent_token"));
    }
    const config = {
      "content-type": "application/json",
    };
    try {
      await Instance.put(`/api/v1/deleteAgentTodo/${id}`, config);
      dispatch({
        type: actions.DELETE_TODO_APP_CHECKBOX,
      });
      toast.warn("todo remove from Todo List");
    } catch (error) {}
  };
};

export const Add_Task_Calendar = (data) => {
  return async (dispatch) => {
    if (localStorage.GPC_Agent_token) {
      setToken(localStorage.getItem("GPC_Agent_token"));
    }
    const config = {
      "content-type": "application/json",
    };
    try {
      const res = await Instance.post(
        `/api/v1/TaskCalender`,
        { ...data },
        config
      );
      dispatch({
        type: actions.CREATE_TASK_CALENDAR,
        payload: res.data.data,
      });
    } catch (error) {}
  };
};

export const Get_List_Calendar = () => {
  return async (dispatch) => {
    if (localStorage.GPC_Agent_token) {
      setToken(localStorage.getItem("GPC_Agent_token"));
    }
    const config = {
      "content-type": "application/json",
    };
    try {
      const res = await Instance.get(`/api/v1/TaskCalenderAgent`, config);
      dispatch({
        type: actions.GET_LIST_CALENDAR_APP,
        payload: res.data.data,
      });
    } catch (error) {}
  };
};
export const View_Each_Task = (taskId) => {
  return async (dispatch) => {
    if (localStorage.GPC_Agent_token) {
      setToken(localStorage.getItem("GPC_Agent_token"));
    }
    const config = {
      "content-type": "application/json",
    };
    try {
      const res = await Instance.get(`/api/v1/TaskCalender/${taskId}`, config);
      dispatch({
        type: actions.VIEW_TASK_CALENDAR,
        payload: res.data.data,
      });
    } catch (error) {}
  };
};
